import React from "react";
import { FormFull } from "form-full";
import Styles from "../styles/Styles";
import { Grid } from "@material-ui/core";
import { Input, InputAutocomplete } from "../../../components/index";
import { masks } from "../../../utils";
import { Label } from "../../../components/inputs/Input";
import InputDate from "../../../components/inputs/InputDate";
import { addOneDay } from "../../registerTenant/components/ModalRegistry";

function Filters({ onSubmit, loading, placeList }) {
  const [minDate, setMinDate] = React.useState<any>(null);
  const [formRef, setFormRef] = React.useState<any>(null);

  return (
    <FormFull formRef={setFormRef} onSubmit={(data) => onSubmit(data)}>
      <Grid container spacing={1}>
        <Grid item xs={12} md={6} lg={2}>
          <Input
            name="name"
            label="NOME COMPLETO"
            placeholder="Nome Completo"
          />
        </Grid>
        <Grid item xs={12} md={6} lg={2}>
          <Input
            name="phone"
            label="TELEFONE"
            placeholder="Telefone"
            mask={masks.inputMaskTELWithDDD}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={2}>
          <Input name="email" label="E-mail" placeholder="E-mail" />
        </Grid>
        <Grid item xs={12} md={6} lg={2}>
          <InputAutocomplete
            readOnly={false}
            disableError
            name="placeId"
            label="Imóvel"
            options={placeList ? placeList : []}
          />
        </Grid>
        <Grid container item xs={12} md={12} lg={4} >
          <div style={{ display: "flex" , flexDirection: "row", alignItems: "center" , width: "100%"}}>
            <div style={{ width: "100%"}}>
              <Label style={{ marginBottom: "11px"}}>ESTADIA</Label>
              <InputDate
                onChange={(value) => {
                  setMinDate(value);
                  const end = formRef?.getValue("endDate");
                  if (end < value) {
                    formRef?.clearValue("endDate", false);
                  }
                }}
                name="minStartDate"
                />
            </div>
            <p style={{ padding: "0px 10px"}}>até</p>
            <div style={{ width: "100%", marginTop: "auto" }}>
              <InputDate minDate={addOneDay(minDate)} name="maxEndDate" />
            </div>
          </div>
        </Grid>
      </Grid>
      <Styles.ButtonContainer>
        <Styles.Clear
          loading={loading}
          disabled={loading}
          fullWidth={false}
          action="clear"
        >
          Limpar
        </Styles.Clear>
        <Styles.Submit
          loading={loading}
          disabled={loading}
          fullWidth={false}
          action="submit"
        >
          Aplicar Filtros
        </Styles.Submit>
      </Styles.ButtonContainer>
    </FormFull>
  );
}

export default Filters;
